import cx from 'classnames'
import { useState } from 'react'
import type { ReactNode } from 'react'

import classes from './styles.module.scss'

type Props = {
  children: ReactNode
  title: string
  isPreopened?: boolean
  mobileLabel?: {
    text: string
    className?: string
  }
  icon?: ReactNode
  'data-test': string
}

export default function VerificationAccordion(props: Props) {
  const { children, title, isPreopened, icon } = props
  const [isOpened, setIsOpened] = useState(isPreopened)

  const handleTitleClick = () => {
    setIsOpened(!isOpened)
  }

  return (
    <div className={classes.accordion} data-test={props['data-test']}>
      <div
        className={cx('mt-typography-h5', classes.title, classes.hasArrow, { [classes.arrowUp]: isOpened })}
        onClick={handleTitleClick}
      >
        {icon}
        {title}
        {props.mobileLabel?.text && (
          <div className={cx(props.mobileLabel?.className && props.mobileLabel?.className)}>
            {props.mobileLabel?.text}
          </div>
        )}
      </div>
      <div className={cx(classes.accordionBody, { [classes.expanded]: isOpened })}>{children}</div>
    </div>
  )
}
